import { render } from "./UserDetailPage.vue?vue&type=template&id=319df8b8&scoped=true"
import script from "./UserDetailPage.vue?vue&type=script&lang=js"
export * from "./UserDetailPage.vue?vue&type=script&lang=js"

import "./UserDetailPage.vue?vue&type=style&index=0&id=319df8b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319df8b8"]])

export default __exports__